import axios from '../utils/axios';

export const track = (data) => {
	return axios.post('/api/subscriptions/track', data);
};

export const update = (data) => {
	return axios.put(`/api/subscriptions/track/${data?.id}`, data);
};
